import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Layouts
import DashboardLayout from '../../layouts/DashboardLayout'
import { Container } from '../../layouts/Container/Container'
// Components
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import AppPageHeader from '../../components/AppPageHeader'

// ant
// Mobx
import { inject, observer } from 'mobx-react'
import MissionCreateForm from './MissionCreateForm'
import { systemName } from '../../config'

const MissionCreatePage = props => {
  const { history, selectPeopleStore } = props

  useEffect(() => {
    return () => {
      selectPeopleStore.clearSelected()
    }
  }, [])

  const handleAfterCreatedMission = () => {
    history.push('/mission')
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tạo mới nhiệm vụ | {systemName} tạo mới nhiệm vụ</title>
      </Helmet>
      <AppPageHeader title="Tạo mới nhiệm vụ" />
      <MissionCreateForm
        handleAfterCreatedMission={handleAfterCreatedMission}
      />
    </DashboardLayout>
  )
}

export default inject('selectPeopleStore')(observer(MissionCreatePage))
